export default __webpack_public_path__ + "static/media/sinpar2.0f0d1930.jpg";